export default __webpack_public_path__ + "static/media/34.b90a9c44.png";